module.exports = __webpack_public_path__ + "6496c882fd0a321144b8f72337b93c3e.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-sam.png
// module id = 662
// module chunks = 0